var BrandclubEventType = /* @__PURE__ */ ((BrandclubEventType2) => {
  BrandclubEventType2["PageView"] = "PageView";
  BrandclubEventType2["NavigateToRetailer"] = "NavigateToRetailer";
  BrandclubEventType2["AddToCart"] = "AddToCart";
  BrandclubEventType2["OrderSubmitted"] = "OrderSubmitted";
  BrandclubEventType2["PurchaseConfirmed"] = "PurchaseConfirmed";
  BrandclubEventType2["ViewCart"] = "ViewCart";
  BrandclubEventType2["InitiateCheckout"] = "InitiateCheckout";
  BrandclubEventType2["OrderConfirmation"] = "OrderConfirmation";
  return BrandclubEventType2;
})(BrandclubEventType || {});
export {
  BrandclubEventType
};
//# sourceMappingURL=types.js.map
